export default __webpack_public_path__ + "static/hall04-bs-nosepick-hall04-banks-04fe9ae0ba7358ea8418b16f1c279984.jpg";